import moment from 'moment';

export default function (games) {
  let currentGameIndex;
  const now = moment();

  const sorted = games
    // eslint-disable-next-line no-nested-ternary
    .sort((a, b) => (a.start > b.start ? 1 : (a.start < b.start ? -1 : 0)))
    .map(game => ({ ...game, start: moment(game.start, 'YYYY-MM-DD HH:mm:ss') }));

  currentGameIndex = sorted
    .findIndex((game) => {
      return now > game.start.clone().subtract(3, 'h')
        && now < game.start.clone().add(6, 'h');
    });

  if (currentGameIndex < 0) {
    currentGameIndex = sorted
      .findIndex((game, g) => !game.end && now < game.start);
  };
  return currentGameIndex;
}



// WEBPACK FOOTER //
// ./src/utils/get-current-game-index.js